module.exports = __webpack_public_path__ + "static/media/bus-alt.900c47bd.svg";